/* SupplierInvoices.tsx
    Une page affichant la gestion des factures fournisseurs
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les éléments
    Utilise l'API correspondante pour les opérations de données
*/

import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { SupplierInvoicesCrudCard } from 'features/supplierInvoices/components/SupplierInvoicesCrudCard';
import PageHeader from 'layout/PageHeader';

export const SupplierInvoices = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faFileInvoiceDollar}
			title="Factures fournisseurs"
			subtitle="Gérez les factures de vos fournisseurs"
		/>
		<SupplierInvoicesCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);

export default SupplierInvoices;
